module.exports = __webpack_public_path__ + "img/rent-car-low-size.3c1f16bd.png";